// extracted by mini-css-extract-plugin
module.exports = {"category":"Cards_category__YKotF","text":"Cards_text__2X23g","cards":"Cards_cards__2jfsE","card":"Cards_card__2FTMN","plus":"Cards_plus__GjK3j"};